<template>
  <div id="payment-filter">
    <img
      @click="$emit('closeDialog')"
      class="close-icon"
      src="../../assets/icons/close.png"
      alt="Close"
    >
    <v-container>
      <v-layout row wrap>
        <v-form style="width:100%" v-model="valid">
          <div v-if="filterType == 'date'">
            <h1 class="header-text">
              <span>Filter po godini i mjesecu
                <div class="header-text-line"></div>
              </span>
            </h1>
            <v-flex xs12>
              <v-select :rules="rules.required" label="Godina" v-model="filter.Year" :items="years"></v-select>
            </v-flex>
            <v-flex xs12>
              <v-select
                label="Mjesec"
                v-model="filter.Month"
                :rules="rules.required"
                :items="months"
                item-text="Name"
                item-value="Id"
              ></v-select>
            </v-flex>
          </div>
          <div v-else>
            <h1 class="header-text">
              <span>Filter po korisniku
                <div class="header-text-line"></div>
              </span>
            </h1>
            <v-flex xs12>
              <v-autocomplete
                v-model="filter.UserId"
                :items="attendends"
                :loading="isLoading"
                :search-input.sync="attendendsSearch"
                chips
                clearable
                hide-details
                :rules="rules.required"
                hide-selected
                item-text="Name"
                item-value="UserId"
                label="Pretraga po korisniku"
                solo
              >
                <template slot="no-data">
                  <v-list-tile>
                    <v-list-tile-title>Pretraga korisnika</v-list-tile-title>
                  </v-list-tile>
                </template>
                <template slot="selection" slot-scope="{ item, selected }">
                  <v-chip :selected="selected" color="blue-grey" class="white--text">
                    <img
                      :src="item.ProfileUrl"
                      class="exstra-small-profile"
                      alt="User profile image"
                    >
                    <span v-text="item.Name"></span>
                  </v-chip>
                </template>
                <template slot="item" slot-scope="{ item, tile }">
                  <img :src="item.ProfileUrl" class="small-profile" alt="User profile image">
                  <v-list-tile-content>
                    <v-list-tile-title v-text="item.Name"></v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
          </div>
          <v-flex xs12 class="text-right actions">
            <v-btn class="main-btn" :disabled="!valid" @click="filterPayments">Filter</v-btn>
          </v-flex>
        </v-form>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  props: ["filterType", "years", "months"],
  data() {
    return {
      filter: {},
      attendends: [],
      isLoading: false,
      attendendsSearch: null,
      valid: false,
      rules: {
        required: [v => !!v || "Polje je obavezno"]
      }
    };
  },
  methods: {
    getAttendends() {
      this.$store.state.services.userService
        .attendendsList()
        .then(response => {
          this.attendends = response.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    filterPayments() {
      this.$emit("resetSelectedPage");
      this.$emit("filterPayments", this.filter);
    }
  },
  watch: {
    attendendsSearch() {
      //TODO -> optimize with search by name if possible
      if (this.attendends.length > 0) {
        return;
      }
      this.isLoading = true;
      this.getAttendends();
    }
  }
};
</script>

<style scoped>
#payment-filter {
  background-color: white;
  position: relative;
  padding: 10px 20px;
}
.header-text {
  margin-bottom: 20px;
}
.small-profile {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 10px;
}
.exstra-small-profile {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 5px;
}
.actions {
  padding-top: 20px;
}
</style>
